/**
 * Project : workspace
 * File    : MyBusinessAccountsScreens.kt
 * Created : AUTO-GENERATED by scripts/add_kdoc.py
 */

package presentation.screens.business.store.accoun

import androidx.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import component.navigation.TopNavBar
import navigation.AppNavigator


/**
 * Represents the my business accounts screens class.
 */


class MyBusinessAccountsScreens{
    @Composable
    fun Content() {
        Column {
            TopNavBar(
                "PaymentModes", onBackPress = {
                    AppNavigator.shared().goBack()
                }
            )
        }
    }
}